<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  reaction: { type: Object, required: true },
});
const { t } = useI18n();
const tooltip = computed(() =>
  t('CONVERSATION.WHATSAPP_REACTION.SENT_BY', {
    agent: props.reaction.agentName,
    time: new Date(props.reaction.reactedAt).toLocaleString(),
  })
);
</script>

<template>
  <span
    class="inline-flex rounded-full border border-n-weak bg-n-solid-1 px-2 py-0.5 text-sm"
    :title="tooltip"
    :aria-label="tooltip"
    data-testid="whatsapp-reaction-badge"
  >
    {{ reaction.emoji }}
  </span>
</template>
